import React from 'react';
import { CONTACT_EMAIL } from './auth-utils';

// Makes our contact address clickable wherever it appears in a message. The address
// is our own constant, so we split on it literally — no email parsing/validation needed.
export const linkifyContactEmail = (text?: string): React.ReactNode => {
  if (!text) return null;
  const segments = text.split(CONTACT_EMAIL);
  if (segments.length === 1) return text;
  return segments.flatMap((segment, i) => (i === 0
    ? [segment]
    : [
      <a key={i} href={`mailto:${CONTACT_EMAIL}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
        {CONTACT_EMAIL}
      </a>,
      segment,
    ]));
};
